// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatRoomDateDivider_main__3MVJS","line":"ChatRoomDateDivider_line__qFGvv","date-text":"ChatRoomDateDivider_date-text__2_x33"};